import React from 'react';
import { withLocalize } from 'react-localize-redux';
import BbInput from '../styling/bbInput';
import { Formik, Form } from 'formik';
import { apiGet, getHostApi } from '../../store/apiWrapper';
import Message from '../common/message';
import { Circles } from '../common/loadingComponent';

class ClientInfo extends React.Component {
    mounted = true;

    state = {
        error: null,
        isLoading: false,
        clientInfo: {
            ico: '',
            companyName: '',
            dic: '',
            icDph: '',
            street: '',
            pobox: '',
            city: '',
            zip: '',
            phone: '',
            fax: ''
        }
    };

    componentDidMount() {
        this.setState({ error: null, isLoading: true });
        apiGet(`${getHostApi()}/api/account/customer`, null,
            res => this.mounted && this.setState({
                clientInfo: {
                    ico: res.data.ico,
                    companyName: res.data.name,
                    dic: res.data.dic,
                    icDph: res.data.icDph,
                    street: res.data.street,
                    pobox: res.data.pobox,
                    city: res.data.city,
                    zip: res.data.zip,
                    phone: res.data.phone,
                    fax: res.data.fax
                }
            }),
            _ => this.mounted && this.setState({ error: this.props.translate('Common.Error') }),
            _ => this.mounted && this.setState({ isLoading: false })
        );
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        return (<>
            <div className='card card-special'>
                <div className='card-body'>
                    {this.state.isLoading ? <Circles /> : <>
                        {this.state.error && <><Message type='error' message={this.state.error} /><br /></>}
                        <Formik
                            enableReinitialize
                            initialValues={this.state.clientInfo}
                            render={_ => (
                                <Form>
                                    <BbInput type='text' name='companyName' label={this.props.translate('User.ClientInfo.ClientName')} placeholder={{ type: 'column' }} disabled />
                                    <BbInput type='text' name='ico' label={this.props.translate('User.ClientInfo.Ico')} placeholder={{ type: 'column' }} disabled />
                                    <BbInput type='text' name='dic' label={this.props.translate('User.ClientInfo.Dic')} placeholder={{ type: 'column' }} disabled />
                                    <BbInput type='text' name='icDph' label={this.props.translate('User.ClientInfo.IcDph')} placeholder={{ type: 'column' }} disabled />
                                    <BbInput type='text' name='street' label={this.props.translate('User.ClientInfo.Street')} placeholder={{ type: 'column' }} disabled />
                                    <BbInput type='text' name='city' label={this.props.translate('User.ClientInfo.City')} placeholder={{ type: 'column' }} disabled />
                                    <BbInput type='text' name='zip' label={this.props.translate('User.ClientInfo.Zip')} placeholder={{ type: 'column' }} disabled />
                                    <BbInput type='text' name='phone' label={this.props.translate('User.ClientInfo.Phone')} placeholder={{ type: 'column' }} disabled />
                                    <BbInput type='text' name='pobox' label={this.props.translate('User.ClientInfo.Pobox')} placeholder={{ type: 'column' }} disabled />
                                    <BbInput type='text' name='fax' label={this.props.translate('User.ClientInfo.Fax')} placeholder={{ type: 'column' }} disabled />
                                </Form>
                            )} />
                    </>}
                </div>
            </div>
        </>)
    }
}

export default withLocalize(ClientInfo);